/* global document */

import countTo from 'vue-count-to';

import './Graph.scss';
import template from './Graph.vhtml';


export default {
	name: 'Graph',
	components: { countTo },
	template: template,
	props: {
		backgroundColor: {
			type: String,
			default: '#F2EFE6',
		},
		percent: {
			type : Number,
			required: true,
		},
		description: {
			type: String,
			default: '',
		},
		source: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		isInView: false,
		circleIndicator: {strokeDasharray: '0 1000 1000'},
		startVal: 0,
	}),
	watch: {
		isInView() {
			this.setGraph();
		}
	},
	methods: {
		setGraph() {
			if (this.isInView) {
				const dasharrayValue = 1000 - (this.percent * 10);
				this.circleIndicator = { strokeDasharray: `0 ${dasharrayValue} 1000` };
			} else {
				this.circleIndicator = { strokeDasharray: '0 1000 1000' };
			}
		},
		toggleIsInView() {
			this.isInView = true;
		}
	},
	mounted() {
		this.$options.aosFunc = this.toggleIsInView;
		document.addEventListener('aos:in:graph', this.$options.aosFunc);
	},
	beforeDestroy() {
		document.removeEventListener('aos:in:graph', this.$options.aosFunc);
	}
};
